module.exports = __webpack_public_path__ + "static/HB1-scaled-92ea61b92d684f3bf66d6a5bfb3b3e65.jpeg";